import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import BlockIcon from '@material-ui/icons/Block';

const ActiveIcon = ({active}) => {
  return active ? <CheckCircleIcon style={{ color: '#2D941F' }}/> : <BlockIcon style={{ color: '#DD0000' }}/>;
}


export default ActiveIcon;
